import { CheckmarkCircleFillIcon, XMarkOctagonFillIcon, InformationSquareFillIcon } from '@navikt/aksel-icons';
import { SSOConnectionUtils } from '../../features/sso/utils/ssoConnectionUtils';
import { ConnectionCard } from './ConnectionCard';
import { ConnectionsSectionProps } from './types';
import classes from './SSOSettings.module.css';

export const ConnectionsSection = ({
  connections,
  uiStateManager,
  onDisable,
  onReEnable,
  t,
}: ConnectionsSectionProps) => {
  const activeConnections = SSOConnectionUtils.filterActiveConnections(connections);
  const disabledConnections = SSOConnectionUtils.filterDisabledConnections(connections);

  return (
    <div className={classes.connectionsSection}>
      <span className={classes.sectionLabel}>{t('ssoSettings.sectionLabels.connections')}</span>
      {activeConnections.length > 0 && (
        <div className={classes.connectionGroup}>
          <div className={classes.groupHeader}>
            <CheckmarkCircleFillIcon className={classes.groupIconActive} aria-hidden />
            <h3>{t('ssoSettings.activeConnections.title')}</h3>
          </div>
          {activeConnections.map((conn) => (
            <ConnectionCard
              key={conn.id}
              connection={conn}
              uiStateManager={uiStateManager}
              onDisable={onDisable}
              onReEnable={onReEnable}
              t={t}
            />
          ))}
        </div>
      )}

      {disabledConnections.length > 0 && (
        <div className={classes.connectionGroup}>
          <div className={classes.groupHeader}>
            <XMarkOctagonFillIcon className={classes.groupIconDisabled} aria-hidden />
            <h3>{t('ssoSettings.disabledConnections.title', { defaultValue: 'Deaktiverte tilkoblinger' })}</h3>
          </div>
          <div className={classes.disabledConnectionsInfo}>
            <InformationSquareFillIcon aria-hidden />
            <p>{t('ssoSettings.disabledConnections.info', { defaultValue: 'Disse tilkoblingene er deaktivert. Klikk "Reaktiver" for å aktivere dem igjen.' })}</p>
          </div>
          {disabledConnections.map((conn) => (
            <ConnectionCard
              key={conn.id}
              connection={conn}
              uiStateManager={uiStateManager}
              onDisable={onDisable}
              onReEnable={onReEnable}
              t={t}
            />
          ))}
        </div>
      )}
    </div>
  );
};
